exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\niframe[data-v-f8fcc994] {\n    height: calc(100% - 48px);\n    border: 0 none;\n    width: 100%;\n}\n@media screen and (min-width: 960px) {\niframe[data-v-f8fcc994] {\n        height: calc(100% - 64px);\n}\n}\n", ""]);

// exports
